import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  settings: {},
};

const UDStorage = window.localStorage.getItem("settings");
if (UDStorage) initialState = { settings: JSON.parse(UDStorage) };

export const userSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.settings = action.payload;
      window.localStorage.setItem("settings", JSON.stringify(action.payload));
    },
  },
});

export const { setSettings } = userSlice.actions;

export default userSlice.reducer;
